import {createContext, useState} from "react";

export const UnitContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [units, setUnits] = useState([]);

    // Make the context object:
    const unitContext = {
        units,
        setUnits,
    };

    // pass the value in provider and return
    return <UnitContext.Provider value={unitContext}>{children}</UnitContext.Provider>;
}

export const {Consumer} = UnitContext;
